module.exports = __webpack_public_path__ + "static/media/alipio.ce056110.jpeg";